import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ContactUs } from "../axios";
import { useLocation } from "react-router-dom";

const Contact = () => {
  useEffect(() => {
    ContactUs().then(({ data }) => {
      // console.log(data);
    });
  }, []);

  const contactList = [
    { id: 1, title: "پشیتیبانی تلگرام", link: "https://t.me/Atropine_admin" },
    {
      id: 2,
      title: "پشتیبانی واتساپ",
      link: "https://wa.me/+989214104104",
    },
    {
      id: 3,
      title: "پیچ اینستاگرام آتروپین",
      link: "https://instagram.com/Atropine.ir/",
    },
    {
      id: 4,
      title: "کانال مشاوره آتروپین",
      link: "https://t.me/Atropine_group",
    },
    {
      id: 5,
      title: "کانال ارولوژی آتروپین",
      link: "https://t.me/Atropine_urology",
    },
    {
      id: 6,
      title: "کانال پوست آتروپین",
      link: "https://t.me/Atropine_dermathology",
    },
    {
      id: 7,
      title: "کانال ارتوپدی آتروپین",
      link: "https://t.me/Atropine_orthopedy",
    },
    {
      id: 8,
      title: "کانال نورولوژی آتروپین",
      link: "https://t.me/Atropine_neurology",
    },
  ];

  const { pathname } = useLocation();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return (
    <React.Fragment>
      <div className="breadcrumbs_area">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb_content">
                <ul>
                  <li>
                    <Link to="/">خانه</Link>
                  </li>
                  <li>تماس با ما</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ marginTop: "2rem" }} className="contact_area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="contact_message content">
                <h3>تماس با ما</h3>
                <p>
                  با ما از مسیر های زیر در ارتباط باشید. محتواهای رایگان مجموعه
                  آتروپین را از پیج اینستگرام و کانال های زیر ببینید (روی قسمت
                  مد نظر کلیک کنید).
                </p>
                <ul>
                  {contactList.map((item) => {
                    return (
                      <li key={item.id}>
                        <a
                          className="instagram"
                          target="_blank"
                          href={item.link}
                        >
                          {item.title}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Contact;
